import { SOURCE_ID_MAP } from '@/enum/const.js'
import { getParamsFromUrl } from '../utils'
import { $t } from '@/i18n'
import { wsReport } from '../utils/utils'
import { customLog } from '../utils/log2'

const actionMap = {}

class WS {
  constructor () {
    if (typeof window.qt !== 'undefined') return
    const urlParams = getParamsFromUrl()
    this.isFormClient = urlParams.source_id === SOURCE_ID_MAP.MICRO_TERMINAL
    this.port = urlParams.port ?? '8082'
    this.token = urlParams.token
    this.fpid = urlParams.fpid || ''
    this.flag = 0

    if (!this.isFormClient) return
    this.URL = `${process.env.VUE_APP_CLIENT_API}:${this.port}?token=${this.token}`
    this.pushQueue = []

    // 定时器，发送请求后 60s 无响应自动返回
    this.timer = null
    this.timeStep = 10000

    this.connect()
  }

  connect (conf) {
    // 重连超过三次后不再重连
    if (this.flag === 3) return
    this.websocket = new WebSocket(this.URL)

    this.websocket.onopen = () => {
      if (this.pushQueue.length) {
        this.push(this.pushQueue.pop())
        this.pushQueue = []
      } else {
        window.$Spin.hide()
      }
    }

    this.websocket.onerror = () => {
      if (++this.flag === 3) {
        window.$Spin.hide()
        window.$msg.success($t('KGSDK_500000'))
        wsReport({
          code: 500000,
          action: 'connection',
          request: ''
        })
        customLog(500000, { action: 'connection', port: this.port }, {})
      } else {
        this.connect(conf)
      }
    }
  }

  // 设置接受函数
  setMessage (fn, params) {
    this.timer && clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      window.$msg.success($t('KGSDK_500002'))
      window.$Spin.hide()
      fn && fn({
        code: 500002,
        action: params.action,
        once_key: params.once_key
      })
    }, this.timeStep)

    this.websocket.onmessage = resp => {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      window.$Spin.hide()
      const data = JSON.parse(resp.data || '{}')
      if (data.action === 'close_window') {
        return window.close()
      }
      if (data.action === 'get_bind_info') {
        this.fpid = data.fpid
      }
      if (fn) {
        if (data.code !== 0) {
          wsReport({
            ...data,
            request: actionMap[data.once_key]
          })
          customLog(data.code, actionMap[data.once_key], data)
        } else {
          delete actionMap[data.once_key]
        }
        fn(data)
      }
    }
  }

  // 发送信息
  send (params) {
    if (typeof params !== 'string') {
      params = JSON.stringify({
        ...params,
        fpid: this.fpid || ''
      })
    }
    params = JSON.parse(params)
    if (this.flag >= 3) {
      window.$msg.success($t('KGSDK_500000'))
      window.$Spin.hide()
      wsReport({
        code: 500000,
        ...params,
        request: params
      })
      customLog(500000, { ...(params || {}), port: this.port }, {})
    } else {
      window.$Spin.show()
      this.websocket.send(JSON.stringify(params))
      actionMap[params.once_key] = params
    }
  }

  // 向 websocket/微端 发送消息, 包含发消息和处理消息的函数定义
  push (conf) {
    if (!this.isFormClient) return
    if (this.websocket.readyState === 0) {
      return this.pushQueue.push(conf)
    }
    const { params = {}, cb = () => {} } = conf
    if (this.websocket.readyState === 3) {
      cb({ code: 500001, action: params.action, once_key: params.once_key })
      wsReport({
        code: 500001,
        ...params,
        request: params
      })
      customLog(500001, { ...(params || {}), port: this.port }, {})
      window.$Spin.hide()
      return
    }
    this.setMessage(cb, params)
    this.send(params)
  }
}

const socket = window.__fpsocket = new WS()

export default socket
